import { MULTI_FACTOR_AUTHENTICATION } from 'config/flags';

export type LeftNavigationItem = {
  name?: string;
  linkTextKey?: string;
  linkPath?: string;
  menuOptions?: Array<{
    name?: string;
    linkTextKey?: string;
    linkPath?: string;
  }>;
};

export const allRoutes = {
  myAccount: {
    name: 'myAccount',
    linkTextKey: 'leftNav.myAccount',
    linkPath: '/',
  },
  profile: {
    name: 'profile',
    linkTextKey: 'leftNav.profile',
    linkPath: '/profile',
  },
  signInAndSecurity: {
    name: 'signInAndSecurity',
    linkTextKey: 'leftNav.signInAndSecurity.label',
    linkPath: '/signin-security',
  },
  mfa: {
    name: 'mfa',
    linkTextKey: 'leftNav.signInAndSecurity.mfa',
    linkPath: '/signin-security/mfa',
  },
  signInActivity: {
    name: 'signInActivity',
    linkTextKey: 'leftNav.signInAndSecurity.signInActivity',
    linkPath: '/signin-security/activity',
  },
  privacyAndData: {
    name: 'privacyAndData',
    linkTextKey: 'leftNav.privacy.privacyAndData',
    linkPath: '/privacy-and-data',
  },
  dataStream: {
    name: 'dataStream',
    linkTextKey: 'leftNav.privacy.dataStream',
    linkPath: '/privacy-and-data/data-stream',
  },
  dataStreamSetup: {
    name: 'dataStreamSetup',
    linkTextKey: 'leftNav.privacy.dataStreamSetup',
    linkPath: '/privacy-and-data/data-stream/setup',
  },
  downloadData: {
    name: 'downloadData',
    linkTextKey: 'leftNav.privacy.downloadData',
    linkPath: '/privacy-and-data/data-requests',
  },
  termsAndConditions: {
    name: 'termsAndConditions',
    linkTextKey: 'leftNav.termsAndConditions',
    linkPath: '/terms-and-conditions',
  },
};

const buildMenuOptions = function () {
  const options: LeftNavigationItem[] = [];
  if (MULTI_FACTOR_AUTHENTICATION) {
    options.push(allRoutes.mfa);
  }
  options.push(allRoutes.signInActivity);
  return options;
};

export const navigationLeft: LeftNavigationItem[] = [
  allRoutes.profile,
  {
    ...allRoutes.signInAndSecurity,
    menuOptions: buildMenuOptions(),
  },
  allRoutes.privacyAndData,
  allRoutes.termsAndConditions,
];
